module.exports = {"id":"dp3_3l3q2","text":"Copyright and licences","instructions":"Which licence is designed to allow reuse under clear conditions?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.3","questionType":"PickOne","random":true,"options":[{"id":"dp3_3l3q2-a1","text":"Creative Commons licence","score":3.7},{"id":"dp3_3l3q2-a2","text":"Commercial trademark","score":1.3},{"id":"dp3_3l3q2-a3","text":"Software patent","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.3/l3q2.json
// module id = 1161
// module chunks = 41